export const Images = {
    profile: require("./iProfile.png"),
    selectedFavourite: require("./favouriteSelected.png"),
    favourite: require("./favourite.png"),
    crossIcon: require("./crossIcon.png"),
    rightArrow: require("./rightArrow.png"),
    logo: require("./logo.png"),
    clear: require("./clear.png"),
    iProfile: require("./iProfile.png"),
    cartEmpty: require("./cartEmpty.png"),
    infoGray: require("./infoGray.png"),
    banner1: require("./banner1.webp"),
    banner2: require("./banner2.webp"),
    favourite: require("./favourite.png"),
    TrackUrl: require("./TrackUrl.webp"),
    copy: require("./copy.png"),
    greyChevron: require("./greyChevron.png"),

    AppSliderImage0: require("./appSlider/image.png"),
    AppSliderImage1: require("./appSlider/image1.png"),
    AppSliderImage2: require("./appSlider/image2.png"),
    AppSliderImage3: require("./appSlider/image3.png"),
    AppSliderImage4: require("./appSlider/image4.png"),
    AppSliderImage5: require("./appSlider/image5.png"),

    MensSliderImage1: require("./appSlider/mens/image1.png"),
    MensSliderImage2: require("./appSlider/mens/image2.png"),
    MensSliderImage3: require("./appSlider/mens/image3.png"),
    StylistSliderImage1: require("./appSlider/stylist/image1.png"),
    StylistSliderImage2: require("./appSlider/stylist/image2.png"),
    StylistSliderImage3: require("./appSlider/stylist/image3.png"),
    VideoSliderImage1: require("./appSlider/videos/image1.png"),
    VideoSliderImage2: require("./appSlider/videos/image2.png"),
    VideoSliderImage3: require("./appSlider/videos/image3.png"),

    Web: require("./Web.webp"),
    delivered: require("./delivered.png"),
    cancelled: require("./cancelled.png"),
    about: require("./about.png"),
    aboutNews1: require("./vetir-news-image (1).png"),
    aboutNews2: require("./vetir-news-image (2).png"),
    aboutNews3: require("./vetir-news-image (3).png"),
    appQR: require("./appqrlink.png"),
    aiStylistDeeplinkQR: require("./aistylist/deeplinkQr.png"),
    left: require("./left.png"),
    right: require("./right.png"),
    leftArrow: require("./leftArrow.png"),
    webAddresses: require("./webAddresses.png"),
    webBag: require("./webBag.png"),
    webManageCards: require("./webCard.png"),
    webfavourite: require("./webfavourite.png"),
    webmyprofile: require("./webmyprofile.png"),
    bigfav: require("./bigfav.png"),
    outForDelivery: require("./outForDelivery.png"),
    returned: require("./returned.png"),
    orderSuccess: require("./OrderSuccess.png"),
    AffiliateNetwork: require("./AffiliateNetwork.webp"),
    closetImagesAfterLogin1: require("./closet/afterlogin/1.webp"),
    closetImagesAfterLogin2: require("./closet/afterlogin/2.webp"),
    closetImagesAfterLogin3: require("./closet/afterlogin/3.webp"),
    closetImagesAfterLogin4: require("./closet/afterlogin/4.webp"),
    closetImagesAfterLogin5: require("./closet/afterlogin/5.webp"),
    closetImagesAfterLogin6: require("./closet/afterlogin/6.webp"),
    closetImagesAfterLogin7: require("./closet/afterlogin/7.webp"),
    closetImagesAfterLogin8: require("./closet/afterlogin/8.webp"),

    closetImagesGuest1: require("./closet/guest/1.webp"),
    closetImagesGuest2: require("./closet/guest/2.webp"),
    closetImagesGuest3: require("./closet/guest/3.webp"),
    closetImagesGuest4: require("./closet/guest/4.webp"),
    closetImagesGuest5: require("./closet/guest/5.webp"),
    closetImagesGuest6: require("./closet/guest/6.webp"),
    closetImagesGuest7: require("./closet/guest/7.webp"),
    closetImagesGuest8: require("./closet/guest/8.webp"),

    gloveDigitilImage1: require("./appSlider/GloveDigitil/image1.png"),
    gloveDigitilImage2: require("./appSlider/GloveDigitil/image2.png"),
    gloveDigitilImage3: require("./appSlider/GloveDigitil/image3.png"),

    outfitImagesAfterLogin1: require("./outfits/login/1.webp"),
    outfitImagesAfterLogin2: require("./outfits/login/2.webp"),
    outfitImagesAfterLogin3: require("./outfits/login/3.webp"),
    outfitImagesAfterLogin4: require("./outfits/login/4.webp"),
    outfitImagesAfterLogin5: require("./outfits/login/5.webp"),
    outfitImagesAfterLogin6: require("./outfits/login/6.webp"),

    outfitImagesGuest1: require("./outfits/guest/1.webp"),
    outfitImagesGuest2: require("./outfits/guest/2.webp"),
    outfitImagesGuest3: require("./outfits/guest/3.webp"),
    outfitImagesGuest4: require("./outfits/guest/4.webp"),
    outfitImagesGuest5: require("./outfits/guest/5.webp"),
    outfitImagesGuest6: require("./outfits/guest/6.webp"),

    mensOutfitGuest1: require("./men/outfits/guest/Guest-1.webp"),
    mensOutfitGuest2: require("./men/outfits/guest/Guest-2.webp"),
    mensOutfitGuest3: require("./men/outfits/guest/Guest-3.webp"),
    mensOutfitGuest4: require("./men/outfits/guest/Guest-4.webp"),
    mensOutfitGuest5: require("./men/outfits/guest/Guest-5.webp"),
    mensOutfitGuest6: require("./men/outfits/guest/Guest-6.webp"),

    mensOutfitLogin1: require("./men/outfits/loggedin/Loggedin-1.webp"),
    mensOutfitLogin2: require("./men/outfits/loggedin/Loggedin-2.webp"),
    mensOutfitLogin3: require("./men/outfits/loggedin/Loggedin-3.webp"),
    mensOutfitLogin4: require("./men/outfits/loggedin/Loggedin-4.webp"),
    mensOutfitLogin5: require("./men/outfits/loggedin/Loggedin-5.webp"),
    mensOutfitLogin6: require("./men/outfits/loggedin/Loggedin-6.webp"),

    mensClosetGuest1: require("./men/closet/guest/Guest-1.webp"),
    mensClosetGuest2: require("./men/closet/guest/Guest-2.webp"),
    mensClosetGuest3: require("./men/closet/guest/Guest-3.webp"),
    mensClosetGuest4: require("./men/closet/guest/Guest-4.webp"),
    mensClosetGuest5: require("./men/closet/guest/Guest-5.webp"),
    mensClosetGuest6: require("./men/closet/guest/Guest-6.webp"),

    mensClosetLogin1: require("./men/closet/loggedin/Loggedin-1.webp"),
    mensClosetLogin2: require("./men/closet/loggedin/Loggedin-2.webp"),
    mensClosetLogin3: require("./men/closet/loggedin/Loggedin-3.webp"),
    mensClosetLogin4: require("./men/closet/loggedin/Loggedin-4.webp"),
    mensClosetLogin5: require("./men/closet/loggedin/Loggedin-5.webp"),
    mensClosetLogin6: require("./men/closet/loggedin/Loggedin-6.webp"),

    aistylistImage1: require("./aistylist/slider/Ai-Outfit.webp"),
    aistylistImage2: require("./aistylist/slider/AI-Stylist.webp"),
    aistylistImage3: require("./aistylist/slider/Ai-Product.webp"),

    thumbnailAiStylist: require("./aistylist/thumbnail.webp"),
    aiStylistImage: require("./aistylist/image.webp"),
    returnImage: require("./returnAndRefund.webp"),
    typingGif: require("./aistylist/typing-dots.gif"),
    multiColor: require("./MultiColor.png"),
    forYouImage1: require("./foryou/image1.png"),
    forYouImage2: require("./foryou/image2.png"),

    usaFlag: require("./countriesFlag/usa.png"),
    dislike: require("./dislike.png"),
    greySelect: require("./greySelect.png"),
    blackSelect: require("./blackSelect.png"),
    blueTailor: require("./blueTailor.png"),
    addIcon: require("./addIcon.png"),
};
